<template>
  <v-container>
    <LoadingBar v-if="loading" />
    <div v-else>
      <v-container class="pa-6 pt-10" fluid>
        <v-row>
          <v-col cols="12" class="col-md-6">
            <h1>{{ $t("Edit Post") }}</h1>
          </v-col>
        </v-row>
      </v-container>
      <v-container fluid class="services-list">
        <v-row dense>
          <!-- manage teams -->
          <v-col class="col-sm-12 col-md-12">
            <v-card class="pa-0" flat>
              <v-card-text>
                <v-col cols="6" class="align-center">
                  <v-text-field
                    label="Name"
                    v-model="currentPage.name"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="align-center">
                  <v-text-field
                    label="Description"
                    v-model="currentPage.description"
                  ></v-text-field>
                </v-col>
                <v-col class="align-center">
                  <editor
                    :data="currentPage.content"
                    :readOnly="true"
                    :ref="`editor`"
                  />
                </v-col>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-end">
            <v-col class="text-right">
              <v-btn color="green lighten-2" text @click="saveGame">
                {{ $t("Ok") }}
              </v-btn>
              <v-btn color="red lighten-2" text @click="reset">
                {{ $t("Cancel") }}
              </v-btn>
            </v-col>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-container>
</template>

<script>
import { firebaseApp } from "@/config/firebase";
import firebase from "firebase/app";
const db = firebase.firestore(firebaseApp);

import editor from "../../components/editor.vue";
import gameProvider from "@/modules/Games/data/games";

export default {
  name: "GameExperienceEdit",
  route: {
    path: "/games/experience/edit/:id/:tab",
    name: "Games Experience Edit",
  },
  data: () => ({
    loading: false,
    currentPage: {
      id: 0,
      name: "New Page - " + new Date(),
      description: "",
      content: Object,
      image: "",
    },

    editorexperience: null,
  }),
  components: {
    editor,
    LoadingBar: () => import("../../components/LoadingBar.vue"),
  },
  beforeMount() {
    this.getExperiencePages();
  },
  methods: {
    async saveGame() {
      this.loading = true;
      let self = this;
      let savedData = await this.$refs.editor.childSave();
      this.currentPage.content = savedData;
      self.posts.forEach((page) => {
        if (self.$route.params.tab == page.id) {
          page = self.currentPage;
        }
      });
      gameProvider.getEvent(this.$route.params.id).then(function (event) {
        event.experiencePages = self.posts;
        gameProvider
          .editSingleGame(self.$route.params.id, event)
          .then(function () {
            console.log("Saved");
            self.$router.push(`/games/experience/${self.$route.params.id}`);
          });
      });
    },
    async getExperiencePages() {
      let self = this;
      gameProvider
        .getExperiencePages(self.$route.params.id)
        .then(function (posts) {
          self.posts = posts;
          self.posts.forEach((page) => {
            if (self.$route.params.tab == page.id) {
              self.currentPage = page;
            }
          });
        });
    },
    reset() {
      this.$router.push(`/games/experience/${this.$route.params.id}`);
    },
  },
  mounted: function () {},
};
</script>

<style lang="scss">
a {
  text-decoration-line: none;
}
.services-list {
  .v-card {
    min-height: 250px;
  }
}
</style>
